import { useEffect } from "react";
import { selectIsOwner } from "../../../app/store/reducers/auth/authReducer";
import { getCategoriesAsync, getCategoryCountAsync, selectCategoryFilterOptions } from "../../../app/store/reducers/category/categoryReducer";
import { getCurrenciesAsync, getCurrenciesCountAsync, selectCurrencyFilterOptions } from "../../../app/store/reducers/currency/currencyReducer";
import { productRegisterAsync } from "../../../app/store/reducers/product/productReducer";
import RegisterProduct from "../../../components/monaliza/product/RegisterProduct"
import { Form } from 'antd';
import { useSelector, useDispatch } from 'react-redux';
import { useNavigate } from "react-router-dom"




const ProductRegister = () => {
    const isOwner = useSelector(selectIsOwner)
    const filterCategories = useSelector(selectCategoryFilterOptions)
    const filterCurrencies = useSelector(selectCurrencyFilterOptions)
    const dispatch = useDispatch()
    const navigate = useNavigate()
    const [form] = Form.useForm()
    const initialValues = {
        category_id: null,
        image: null,
        name: "",
        description: "",
        amount: "0",
        currency_id: "",
        residual: "0",
    }


    const onSubmit = async (values) => {
        // console.log("values", values)
        // console.log("test version", form.getFieldValue('image'))
        const image = form.getFieldValue("image")
        const product = {
            category_id: values?.category_id,
            name: values?.name,
            description: values?.description,
            price: {
                amount: values?.amount,
                currency_id: values?.currency_id
            },
            residual: values?.residual,
            image: {
                filename: image?.filename,
                base64: image?.base64,
                size: image?.size
            }
        }
        

        await productRegisterAsync({product})
            .then((response) => {
                // console.log(response);
                navigate("../my")
            })
            .catch((error) => {

            })
    }
  
  
    useEffect(() => {
      if (isOwner) {
        dispatch(getCurrenciesAsync({...filterCategories}))
        dispatch(getCurrenciesCountAsync({...filterCategories}))
        dispatch(getCategoriesAsync({...filterCurrencies}))
        dispatch(getCategoryCountAsync({...filterCurrencies}))
      }
    },[isOwner])


  return (
    <>
        <Form
            form={form}
            initialValues={initialValues}
            layout="vertical"
            onFinish={onSubmit}
        >
            <RegisterProduct/>
        </Form>
    </>
  )
}

export default ProductRegister